import PropTypes from 'prop-types';
import React from 'react';

import CheckOption from './CheckOption';
import Section from './Section';

// Fixed-option facet (History Yes/No, Status On/Off) — all options selected means
// "no filter", so the badge is 0 in that case.
const KeyedFacet = ({ title, options, counts, selected, onToggle, showCounts = true }) => (
  <Section title={title} badge={selected.length === options.length ? 0 : selected.length}>
    <div className="ab-opts">
      {options.map((o) => (
        <CheckOption
          key={o.key}
          label={o.label}
          count={showCounts ? (counts || {})[o.key] || 0 : null}
          on={selected.includes(o.key)}
          onClick={() => onToggle(o.key)}
        />
      ))}
    </div>
  </Section>
);
KeyedFacet.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  counts: PropTypes.object,
  selected: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  showCounts: PropTypes.bool,
};

export default KeyedFacet;
